import {
  callAgentControlFunction,
  listAgentControlFunctions,
} from "./agentControlStore";

type AgentControlProxy = {
  listFunctions: typeof listAgentControlFunctions;
  [key: string]: (...args: unknown[]) => unknown;
};

declare global {
  interface Window {
    _reploAgentControl?: AgentControlProxy;
  }
}

export function initAgentControlWindowApi() {
  const target: AgentControlProxy = {
    listFunctions: listAgentControlFunctions,
  };

  window._reploAgentControl = new Proxy(target, {
    get(_target, prop) {
      if (prop === "listFunctions") {
        return listAgentControlFunctions;
      }
      if (typeof prop === "string") {
        return (...args: unknown[]) => callAgentControlFunction(prop, ...args);
      }
      return undefined;
    },
  });
}
